import { Action } from '@ngrx/store';
import { ReadDeviceChangeHistoryInfo, DeviceChangeHistory, UpdateDeviceLevel } from '../change-info.model';

export enum ChangeInfoActionTypes {
  GET_CHANGE_INFO = '[ChangeInfo] GET_CHANGE_INFOS',
  GET_CHANGE_INFO_SUCCESS = '[ChangeInfo] GET_CHANGE_INFOS_SUCCESS' ,
  GET_CHANGE_INFO_FAIL = '[ChangeInfo] GET_CHANGE_INFOS_FAIL'
  // UPDATE_CHANGE_INFO = '[ChangeInfo] UPDATE_CHANGE_INFOS',
  // UPDATE_CHANGE_INFO_SUCCESS = '[ChangeInfo] UPDATE_CHANGE_INFOS_SUCCESS',
  // UPDATE_CHANGE_INFO_FAIL = '[ChangeInfo] UPDATE_CHANGE_INFOS_FAIL'
}

export class GetChangeInfosAction implements Action {
  readonly type = ChangeInfoActionTypes.GET_CHANGE_INFO;

  constructor(public payload: ReadDeviceChangeHistoryInfo = null) {}
}

export class GetChangeInfosSuccessAction implements Action {
  readonly type = ChangeInfoActionTypes.GET_CHANGE_INFO_SUCCESS;

  constructor(public payload: DeviceChangeHistory[] = null) {
  }
}

export class GetChangeInfosFailAction implements Action {
  readonly type = ChangeInfoActionTypes.GET_CHANGE_INFO_FAIL;

  constructor(public payload: any = null) {
  }
}

// export class UpdateChangeInfosAction implements Action {
//   readonly type = ChangeInfoActionTypes.UPDATE_CHANGE_INFO;
//
//   constructor (public payload: UpdateDeviceLevel[] = null) {
//   }
// }
//
// export class UpdateChangeInfosActionSuccess implements Action {
//   readonly type = ChangeInfoActionTypes.UPDATE_CHANGE_INFO_SUCCESS;
//
//   constructor (public payload: UpdateDeviceLevel[] = null) {
//   }
// }
//
// export class UpdateChangeInfosActionFail implements Action {
//   readonly type = ChangeInfoActionTypes.UPDATE_CHANGE_INFO_FAIL;
//
//   constructor (public payload: any = null) {
//   }
// }

export type ChangeInfoActions = GetChangeInfosAction
  | GetChangeInfosSuccessAction
  | GetChangeInfosFailAction;
  // | UpdateChangeInfosAction
  // | UpdateChangeInfosActionSuccess
  // | UpdateChangeInfosActionFail;
